import { firestore } from '~/firebase/init';
import {
  addDoc,
  collection,
  DocumentData,
  DocumentReference,
  updateDoc,
  setDoc,
} from 'firebase/firestore';
import { PlatformCart } from '~/types/cart';
import { User } from 'firebase/auth';
import { PLATFORM_ID } from '~/globalVariables';

export default async function createGroupCart(
  data: PlatformCart,
): Promise<DocumentReference<DocumentData>> {
  const cartCollectionRef = collection(firestore, 'platforms', PLATFORM_ID, 'carts');

  const res = await addDoc(cartCollectionRef, data);

  return res;
}
